import { c as _c } from "react/compiler-runtime";
import type { BigIntish } from '@morpho-org/blue-sdk';
import { ZERO } from '@morpho-org/dapp-core';
import { DataList } from '@morpho-org/ui-v6/client';
import { memo, useMemo } from 'react';
import { formatTimestampToDate } from '@/helpers/date';
export interface VaultDeploymentDateDataLineProps {
  creationTimestamp?: BigIntish;
}
const VaultDeploymentDateDataLine = t0 => {
  const $ = _c(5);
  const {
    creationTimestamp
  } = t0;
  const t1 = creationTimestamp ?? ZERO;
  let t2;
  if ($[0] !== t1) {
    t2 = formatTimestampToDate(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const formattedDate = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DataList.LeftItem label="Vault deployment date" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== formattedDate) {
    t4 = <DataList.Line>{t3}<DataList.RightItem><span className="text-foreground text-xs">{formattedDate}</span></DataList.RightItem></DataList.Line>;
    $[3] = formattedDate;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default memo(VaultDeploymentDateDataLine);